import { useEffect } from "react";

/** How long the confirmation stays up before closing itself. */
export const LOGGED_IN_MODAL_MS = 2000;

interface LoggedInModalProps {
  /** The address the login opened, or "" when it has none to show. */
  email: string;
  onClose: () => void;
}

/**
 * Confirms a login after the page has moved on to /create. It closes itself
 * after LOGGED_IN_MODAL_MS; the bar filling the dismiss button counts that
 * down, so the person can see it will go away without them.
 */
export function LoggedInModal({ email, onClose }: LoggedInModalProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, LOGGED_IN_MODAL_MS);
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <dialog open className="logged-in-modal" onClick={onClose}>
      <article
        role="dialog"
        aria-modal="true"
        aria-labelledby="logged-in-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="logged-in-title">Logged in</h3>
        {email && (
          <p>
            You're logged in as <strong>{email}</strong>.
          </p>
        )}
        <button type="button" className="logged-in-dismiss" onClick={onClose} autoFocus>
          <span
            className="logged-in-progress"
            style={{ animationDuration: `${LOGGED_IN_MODAL_MS}ms` }}
            aria-hidden="true"
          />
          <span className="logged-in-dismiss-label">OK</span>
        </button>
      </article>
    </dialog>
  );
}
